import { useState } from 'react'
import logo from '.././SAMOH.png'
import napis from '.././transparent_logo (1) (1).png'
import {
  HeaderArea,
  HeaderContainer,
  TextSide,
  Icon,
  NavList,
  ListItem,
  NaviButton,
  Burger,
  MobileMenu,
  LinkNav,
  ButtonNavLink
} from './styled'

const Header = () => {
  const [open, setOpen] = useState(false)

  return (
    <HeaderArea>
      <HeaderContainer>
        <Icon src={logo} alt='Logo Hella Premium' />
        <Icon src={napis} alt='Hella Premium' />
        <Burger onClick={() => setOpen(!open)}>
          <span />
          <span />
          <span />
        </Burger>

        <TextSide>
          <NavList className={open ? 'open' : ''}>
            <ListItem>
              <LinkNav to='/#onas'>O nas</LinkNav>
            </ListItem>
            <ListItem>
              <LinkNav to='/#produkty'>Produkty</LinkNav>
            </ListItem>
            <ListItem>
              <LinkNav to='/#certyfikaty'>Certyfikaty</LinkNav>
            </ListItem>
            <ListItem>
              <LinkNav to='/#kontakt'>Kontakt</LinkNav>
            </ListItem>
          </NavList>

          <NaviButton>
            <ButtonNavLink to='/#probka'>Uzyskaj darmową próbkę</ButtonNavLink>
          </NaviButton>
        </TextSide>
      </HeaderContainer>

      {/* Mobile menu dropdown */}
      <MobileMenu className={open ? 'open' : ''}>
        <ListItem>
          <LinkNav
            to='/#onas'
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            O nas
          </LinkNav>
        </ListItem>
        <ListItem>
          <LinkNav
            to='/#produkty'
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            Produkty
          </LinkNav>
        </ListItem>
        <ListItem>
          <LinkNav
            to='/#certyfikaty'
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            Certyfikaty
          </LinkNav>
        </ListItem>
        <ListItem>
          <LinkNav
            to='/#kontakt'
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            Kontakt
          </LinkNav>
        </ListItem>
      </MobileMenu>
    </HeaderArea>
  )
}

export default Header
